import React, { useState } from 'react';

// Utils
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useAppContext } from '../../../src/store/AppContext';
import { useModal } from '../../../src/store/ModalContext';
import bookingStep from '../../../src/enum/bookingStep';

// Components
import Modal from '../../organisms/Modal/Modal';
import Button from '../../atoms/Button/Button';

import styles from './ResetSearchModal.module.scss';

function ResetSearchModal() {
  const { t } = useTranslation();
  const router = useRouter();
  const [{ userProgress }, stateDispatch] = useAppContext();
  const { isModalOpen, closeModal, setModalDataById } = useModal();

  const [resetIsLoading, setResetIsLoading] = useState(false);
  const [cartIsLoading, setCartIsLoading] = useState(false);

  const isOpen = isModalOpen('modal-reset-search');

  const handleClose = () => closeModal('modal-reset-search');

  const handleResetSearch = () => {
    setResetIsLoading(true);
    setModalDataById('modal-reset-search', { reset: true });
    stateDispatch({ type: 'RESET_BOOKING' });
    closeModal('modal-reset-search');
    setResetIsLoading(false);
  };

  const handleGoToCart = () => {
    if (userProgress && bookingStep.route[userProgress]) {
      setCartIsLoading(true);
      router.push(bookingStep.route[userProgress]);
    }
  };

  return (
    <Modal id="modal-reset-search" title={t('search.reset.title')} isOpen={isOpen} onClose={handleClose}>
      <p className={`${styles.modal_content} m-t-20 fw-400`}>
        {t('search.reset.text')}
      </p>
      <div className="flex a-center j-spb m-t-30 mobile-d-col">
        <Button
          onClick={handleGoToCart}
          classNames="flex-auto m-r-20 mobile-w-100 mobile-m-r-0 mobile-m-b-10"
          text="uppercase"
          color="inverted-secondary"
          isLoading={cartIsLoading}
          disabled={resetIsLoading || cartIsLoading}
        >
          {t('search.reset.no')}
        </Button>
        <Button
          onClick={handleResetSearch}
          classNames="flex-auto mobile-w-100"
          text="uppercase"
          isLoading={resetIsLoading}
          disabled={resetIsLoading || cartIsLoading}
        >
          {t('search.reset.yes')}
        </Button>
      </div>
    </Modal>
  );
}

ResetSearchModal.propTypes = {};

export default ResetSearchModal;
